import { render } from "./AccountContent.vue?vue&type=template&id=18395353"
import script from "./AccountContent.vue?vue&type=script&lang=js"
export * from "./AccountContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../var/local/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__